import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);
export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Index',
            redirect: {
                name: 'login'
            }
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                title: '登录'
            },
            component: () => import('@/components/login')
        },
        {
            path: '/home',
            name: 'home',
            meta: {
                title: '列表'
            },
            component: () => import('@/components/home')
        },
    ]
});